import { render, staticRenderFns } from "./AddMatriculaModal.vue?vue&type=template&id=00162a5e&scoped=true"
import script from "./AddMatriculaModal.vue?vue&type=script&lang=js"
export * from "./AddMatriculaModal.vue?vue&type=script&lang=js"
import style0 from "./AddMatriculaModal.vue?vue&type=style&index=0&id=00162a5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00162a5e",
  null
  
)

export default component.exports